// Importing components for different steps of the withdrawal process
import TransactionModalsWithdrawContentTransactionForm from './Form';
import WithdrawResponse from './Response';
import TransactionsModalsWithdrawContentConfirmation from './Confirmation';
import TransactionsModalsWithdrawContentConfirmationCode from './ConfirmationCode';
import { useWithdrawSearchParams } from '@starsoft/common/hooks';
import { WithdrawStep } from '@starsoft/common/enums';
import UserPaymentDetailsContent from '../../../Common/Layout/UserPaymentDetails';

/**
 * TransactionModalsWithdrawContent Component
 * This component renders different content based on the current withdrawal step.
 *
 * Constants & Hooks:
 * - transactionStep: Retrieved from useWithdrawSearchParams hook, indicates the current step in the withdrawal process.
 *
 * Logic scope:
 * - Switches between different components based on the transactionStep value.
 *
 * @returns {JSX.Element} The component corresponding to the current withdrawal step.
 *
 * @example
 * // If the transactionStep is WithdrawStep.Form, it returns:
 * <TransactionModalsWithdrawContentTransactionForm />
 */
export default function TransactionModalsWithdrawContent() {
  // Destructuring transactionStep from the custom hook to determine the current step
  const { transactionStep } = useWithdrawSearchParams();

  // Switch statement to render the appropriate component based on the transaction step
  switch (transactionStep) {
    case WithdrawStep.Form:
      // Renders the form component for the withdrawal process
      return <TransactionModalsWithdrawContentTransactionForm />;
    case WithdrawStep.UserPaymentDetails:
      // Renders the user payment details component
      return <UserPaymentDetailsContent />;
    case WithdrawStep.Confirmation:
      // Renders the confirmation component
      return <TransactionsModalsWithdrawContentConfirmation />;
    case WithdrawStep.ConfirmationCode:
      // Renders the confirmation code component
      return <TransactionsModalsWithdrawContentConfirmationCode />;
    case WithdrawStep.Response:
      // Renders the response component after the withdrawal process
      return <WithdrawResponse />;
  }
}
